// extracted by mini-css-extract-plugin
export var container = "feature-module--container--UxhQW";
export var cover = "feature-module--cover--ayuLi";
export var feature_image = "feature-module--feature_image--OSNIF";
export var svg = "feature-module--svg--RvsBK";
export var svg_layer = "feature-module--svg_layer--uoJET";